module.exports = __webpack_public_path__ + "img/ennetix-overview-dropdown.7e235166.png";